import buildDashboardMenuSection from './builders/builderDashboard';
import buildMainMenuSection from './builders/builderMain';
import buildSocialMenuSection from './builders/builderSocial';
import buildOtherMenuSection from './builders/builderOther';

export const getMenuJson = ({ preferences, mfp, usageIndicators, advancedReporting, userType }) => {
    const dashboards = buildDashboardMenuSection({ userType });
    const social = buildSocialMenuSection({ userType });
    const other = buildOtherMenuSection({ userType });

    const main = buildMainMenuSection({
        preferences,
        mfp,
        usageIndicators,
        advancedReporting,
        userType
    });

    return {
        dashboards,
        main,
        social,
        other
    };
};
